import { FC } from 'react';

const ActionIconVideoCamera: FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 8L10.5528 9.27639C11.2177 9.60884 12 9.12535 12 8.38197V3.61803C12 2.87465 11.2177 2.39116 10.5528 2.72361L8 4V3C8 2.78234 7.93046 2.58093 7.81239 2.41675C7.63086 2.16436 7.33463 2 7 2H1C0.447715 2 0 2.44772 0 3V8.5C0 9.32843 0.671573 10 1.5 10H7C7.33463 10 7.63086 9.83564 7.81239 9.58325C7.93046 9.41908 8 9.21766 8 9V8ZM8 5.67705V6.32295L10.5 7.57295V4.42705L8 5.67705ZM6.5 3.5V8.5H1.5V3.5H6.5Z"
      fill="currentColor"
    />
  </svg>
);

export { ActionIconVideoCamera };
